import styled from 'styled-components';

const ImageFluid = styled.img`
  width: 100%;
  height: 100%;
`;

export default ImageFluid;
